import { z } from 'zod/v4';

export const AdminUserRevokeSessionsParamsSchema = z.object({
  id: z.string().min(1),
});

export type AdminUserRevokeSessionsParams = z.infer<
  typeof AdminUserRevokeSessionsParamsSchema
>;

/** How many live sessions the call ended (0 when the user had none). */
export const AdminUserRevokeSessionsResponseSchema = z.object({
  revokedCount: z.number().int().nonnegative(),
});

export type AdminUserRevokeSessionsResponse = z.infer<
  typeof AdminUserRevokeSessionsResponseSchema
>;
